
























































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import type { User } from '@/models/user';
import type { Lesson } from '@/models/lesson';
import type { Phase } from '@/models/phase';

import ConceptsList from '@/components/knowledge/concepts/ConceptsList.vue';
import type { Concept } from '@/models/concept';
import SearchField from '@/components/prine/SearchField.vue';
import { hasPermission } from '@/helpers/auth/permissionHelpers';
import { PERMISSIONS } from '@/helpers/auth/permissions';

@Component({
    name: 'ConceptsListGroupedByPhases',
    computed: {
        PERMISSIONS() {
            return PERMISSIONS;
        },
    },
    methods: { hasPermission },
    components: {
        ConceptsList,
        SearchField,
    },
})
export default class ConceptsListGroupedByPhases extends Vue {
    private concepts = new Array<Concept>();
    private conceptsByPhase = new Map<number, Concept[]>();
    // private originalConcepts = new Array<Concept>();
    private isSearching: boolean = false;
    private searchQuery: string = '';
    private filterByLessons: boolean = hasPermission(PERMISSIONS.APPEX_LESSON);

    private isLoaded: boolean = false;
    private isLoading: boolean = false;
    private tableSettings = {
        openedDetailed: Array<number>(),
        isStriped: true,
        isHoverable: true,
        isPaginated: false,
    };

    private selectedPhase: Phase = {} as Phase;

    @Getter('account/userInfo') private userInfo: User;
    @Prop() private originalConcepts: Concept[];
    @Prop() private phases: Phase[];

    @Watch('originalConcepts')
    private onOriginalConceptsChange() {
        this.prepareData();
    }

    @Watch('searchQuery')
    private onSearchQueryValueChange() {
        this.search();
    }

    get activePhaseTabIndex() {
        return this.$store.getters['knowledge/conceptsActivePhaseTabIndex'];
    }

    // noinspection JSUnusedGlobalSymbols
    set activePhaseTabIndex(index: number) {
        this.isLoading = true;
        this.$store.commit('knowledge/setConceptsActivePhaseTabIndex', index);
        setTimeout(() => {
            this.isLoading = false;
        }, 200);
    }

    private mounted() {
        this.prepareData();
    }

    private phaseTabTitle(phase: Phase, index: number) {
        if (this.activePhaseTabIndex === index) {
            return phase.abbreviation + ': ' + phase.title;
        } else {
            return phase.abbreviation;
        }
    }

    private groupConceptsByPhase() {
        // Initialize the trades per phase map
        this.conceptsByPhase = new Map<number, Concept[]>();

        this.phases.forEach((phase) => {
            const filteredConcepts = [] as Concept[];
            this.concepts.forEach((concept: Concept) => {
                concept.topic.lessons_count = concept.topic.lessons.length;
                const filteredLessons = concept.topic.lessons.filter((lesson: Lesson) => {
                    return lesson.phases.findIndex((ob) => ob.id === phase.id) !== -1 || phase.id === 0;
                });

                if (filteredLessons.length > 0 || this.searchQuery.length === 0) {
                    const conceptCopy: Concept = JSON.parse(JSON.stringify(concept));
                    conceptCopy.topic.lessons = concept.topic.lessons;
                    conceptCopy.topic.lessons_count = filteredLessons.length;
                    filteredConcepts.push(conceptCopy);
                }
            });

            this.conceptsByPhase.set(phase.id, filteredConcepts);
        });

        // Add all trades in the index 0
        this.conceptsByPhase.set(0, this.concepts);
    }

    private updateSearchQuery(value: string) {
        this.searchQuery = value;
    }

    private search() {
        this.isSearching = true;

        const regExQuery = new RegExp(this.searchQuery.trim(), 'i');

        const originalConceptsCopy = JSON.parse(JSON.stringify(this.originalConcepts));

        this.concepts = originalConceptsCopy.filter((concept: Concept) => {
            const titleMatch = concept.title.search(regExQuery) !== -1;

            if (this.filterByLessons) {
                const filteredLessons = concept.topic.lessons.filter((lesson: Lesson) => {
                    return lesson.insight.search(regExQuery) !== -1;
                });
                concept.topic.lessons = filteredLessons;
                concept.topic.lessons_count = filteredLessons.length;
                return titleMatch || concept.topic.lessons.length > 0;
            } else {
                return titleMatch;
            }
        });

        this.groupConceptsByPhase();

        this.isSearching = false;
    }

    private async prepareData() {
        this.concepts = JSON.parse(JSON.stringify(this.originalConcepts));
        this.isLoaded = true;
        this.groupConceptsByPhase();
        if (this.$route.query.searchQuery && this.$route.query.searchQuery !== '') {
            this.searchQuery = decodeURIComponent(this.$route.query.searchQuery.toString());
            if (this.$route.query.filterByLessons) {
                this.filterByLessons = this.$route.query.filterByLessons === 'true';
            }
            this.search();
        }
    }

    private rowClicked(concept: Concept) {
        if (hasPermission(PERMISSIONS.APPEX_LESSON)) {
            this.phaseTabChanged(this.activePhaseTabIndex);
            this.$router.push({
                path: '/knowledge/concepts/detailed',
                query: {
                    id: concept.id.toString(),
                    sq: encodeURIComponent(this.searchQuery),
                    fbl: this.filterByLessons.toString(),
                    pid: this.selectedPhase.id ? this.selectedPhase.id.toString() : '0',
                },
            });
        }
    }

    private phaseTabChanged(index: number) {
        // getting buefy tabs component by refs
        const buefyTabs: any = this.$refs.phasesTabs;
        this.selectedPhase = {} as Phase;

        this.phases.forEach((phase) => {
            // checking if the current label of active tab item matches the phase
            // if true set the phase and the selectedPhase
            if (
                phase.abbreviation === buefyTabs.items[index].label ||
                phase.abbreviation + ': ' + phase.title === buefyTabs.items[index].label
            ) {
                this.selectedPhase = phase;
            }
        });
    }

    private clearSearch() {
        // Reset the search query
        this.searchQuery = '';
    }
}
